import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import { influencerInterested } from '../../store/actions/dealActions';
import { retireCampaign } from '../../store/actions/campaignActions';
import { getDealsByCampaignId } from '../../store/selectors/deals';
import { getCampaignHistoricalViews } from '../../store/actions/campaignStatisticsActions';

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    padding: '30px',
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: '100%',
      maxWidth: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  root: {
    width: '100%',
    padding: '30px',
    marginBottom: '40px'
  },
  leftSection: {
    width: '100%',
    marginRight: '10px',
    marginLeft: '10px',
    marginBottom: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  dealsAnalyticsContainer: {
    width: '100%',
    marginLeft: '10px'
  },
  rightSection: {
    width: '100%',
    position: 'relative'
  },
  vPerDAmount: {
    color: '#6441a4'
  },
  totalSpentContainer: {
    width: '100%',
    marginRight: '10px',
    marginLeft: '10px',
    marginTop: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  totalViewsContainer: {
    width: '100%',
    marginRight: '10px',
    marginLeft: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  dealAnalyticsContainer: {
    marginTop: '10px'
  },
  dealsBreakdownPaper: {
    paddingBottom: '20px',
    paddingTop: '20px',
    width: '100%'
  },
  title: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginBottom: '20px'
  },
  dealsTable: {
    width: '100%',
    marginRight: '40px',
    marginLeft: '40px'
  },
  pieChartContainer: {
    display: 'inline-block'
  },
  dealsBreakdownContainer: {
    overflow: 'scroll',

    display: 'flex',
    [theme.breakpoints.down(600)]: {
      flexDirection: 'column'
    }
  },
  youtubeVideoUpload: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: '30px',
    height: '0',
    overflow: 'hidden',
    '& iframe': {}
  },
  iframeContainer: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  },
  campaignContentPaper: {
    width: '100%'
  },
  campaignContentContainer: {
    padding: '20px',
    display: 'inline-flex'
  }
});

const mapStateToProps = (state, ownProps) => {
  return {
    profile: state.firebase.profile,
    auth: state.firebase.auth,
    deals: getDealsByCampaignId(ownProps.campaignId)(state),
    campaignHistoricalViews: state.historical.campaignStats[ownProps.campaignId]
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getCampaignHistoricalViewsHandler: campaignId =>
      dispatch(getCampaignHistoricalViews(campaignId))
  };
};

export default compose(
  withRouter,
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ profile, auth }) => ({
    profile,
    auth
  })),
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/campaign/CampaignAnalytics.enhancer.js